import request from '@/utils/request'
import { ReturnInboundItem, ReturnInboundSearchParams, toSearchPayload } from './types'

/**
 * RGR05 반품조회(전체) 엔드포인트. (1.0 `/api/grid/search` 의 2.0 이관 — moms-be LOGISPRD-9561/9562)
 *
 * | 동작 | 2.0 API                                    | 1.0 MENU_CD |
 * |------|--------------------------------------------|-------------|
 * | 조회 | `POST /api/v1/get-all-return-inbounds`     | RGR05_HEAD  |
 * | 엑셀(비밀번호 zip) | `POST /api/v1/get-all-return-inbounds/download` | RGR05_HEAD  |
 *
 * 평문 `POST …/excel` 은 쓰지 않는다 — 비밀번호 없이 내려가 RGR 화면 규칙에 어긋난다(LOGISPRD-14889). 상수도 두지 않는다.
 *
 * BE 가 `ordType = RETURN` 을 고정하므로 입고유형은 요청 파라미터가 아니다(moms-be#2410).
 */
export const RETURN_INBOUND_SEARCH_URL = '/api/v1/get-all-return-inbounds'
export const RETURN_INBOUND_DOWNLOAD_URL = `${RETURN_INBOUND_SEARCH_URL}/download`

/**
 * 날짜는 `yyyyMMdd` 로 보낸다 — BE 가 `LocalDate.parse(value, FORMATTER_YYYYMMDD)` 로 읽어
 * ISO(`2026-08-27`)를 주면 "날짜 형식이 올바르지 않습니다" 로 400 이 난다.
 * 화면·클라이언트 필터는 ISO 로 통일돼 있어 이 경계에서만 바꾼다.
 */
export const getAllReturnInbounds = (params: ReturnInboundSearchParams) =>
  request.post<ApiResponseV2<ApiPageResponse<ReturnInboundItem>>, ReturnInboundSearchParams>(
    RETURN_INBOUND_SEARCH_URL,
    toSearchPayload(params),
  )
